<!-- src/components/index.vue -->

<template>
  <div class="p-3" v-if="artPost">
    <div class="row no-gutters justify-content-center g-0">
      <div class="col-4 dark-gray-box-1" id="artPostInfo" :class="{'col-6 p-4': imageIsLong && !artPostInfoSmaller, 'col-11 p-3': artPostInfoSmaller, 'p-4': !imageIsLong && !artPostInfoSmaller }">
        <div v-if="userman" class="w-100">
          <div class="d-flex">
            <div class="mx-2 d-flex flex-column align-items-center maxwidthbyscreen100px">
              <img :src="userman.ProfilePicture" class="artist-avatar">
              <a :href="`/profile/${userman.profileurlName || '#'}`" class="textmain textmainhover textmainglowhover text-decoration-none MainTitleFont">{{ userman.name || 'Anon' }}</a>
            </div>
            <div class="p-3">
              <h1 class="textmain MainTitleFont m-0">{{ artPost.name }}</h1>
              <p class="p-1 textsecondary">{{ artPost.description }}</p>
            </div>
          </div>
          <div class="col-12 image-container-post mb-3 mt-3 w-100 align-self-center" v-if="artPostInfoSmaller">
            <a class="d-flex align-self-center justify-content-center ">
              <img :src="artPost.image_url" :alt="artPost.description" class="fullimage-post maxheight80page black-box-shadow">
            </a>
          </div>
          <div class="col-12 section-divider-wide"></div>
          
          <div class="row">
           <div class="col-12 py-2 ">
              <h6 class="px-2 subTitleFont">Comments</h6>
              <p class="px-2 pt-1 textlightgray">Nothing is here</p>
            </div>
          </div>
        </div>
        <div v-else>
            <span>Loading user info...</span>
        </div>
      </div>
      <div class="image-container-post" v-if="!artPostInfoSmaller" :class="{'col-4': imageIsLong, 'col-6': !imageIsLong}">
        <a class="d-flex">
          <img :src="artPost.image_url" :alt="artPost.description" class="fullimage-post maxheight80page black-box-shadow">
        </a>
      </div>
    </div>
  </div>
  <div v-else-if="loading" class="text-center p-4">
    <p>Loading...</p>
  </div>
  <div v-else-if="error" class="text-center p-4">
    <p class="text-danger">{{ error }}</p>
  </div>
</template>
<style scoped>


.image-container-post {
  position: relative;
  overflow: hidden;
}

.fullimage-post {
  max-width: 100%;
  
  width: auto; /* Maintain aspect ratio */
  height: auto; /* Maintain aspect ratio */
  object-fit: contain; /* Ensure the entire image is visible */
  display: block; /* Removes bottom space/margin of inline elements */
}
</style>
<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import AOS from 'aos'; // Import AOS for animations
export default {
  name: 'PostPagePart1Content',
  props: {
    id: String
  },
  data() {
    return {
      artPost: null,
      userman: null,
      loading: true,
      error: null,
      apiUrl: process.env.NODE_ENV === 'production' 
        ? '' 
        : 'http://localhost:3002',
      imageIsLong: false,
      artPostInfoSmaller: false,
      sizeThreshold: 300
    };
  },
  created() {
    if (this.id) {
      //this.fetchUserData(this.id);
      this.fetchWebData('/api/artPosts/', this.id);
    }
  },
  watch: {
    // Watch for changes in the id prop
    id: {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.fetchUserData(newId);
        }
      }
    }
  },
  mounted() {
    // Initialize AOS for animations (if needed)
    AOS.init();
    // Add resize listener
    window.addEventListener('resize', this.onWindowResize);
    // Set initial document title
    this.updateDocumentTitle();
  },
  beforeUnmount() {
    // Clean up resize listener
    window.removeEventListener('resize', this.onWindowResize);
  },
  
  methods: {
    updateDocumentTitle() {
      document.title = (this.artPost?.name || 'Art Post') + " by " + (this.userman?.name || 'Anon');
    },
    onWindowResize() {
      this.artPostInfoSmaller = this.checkArtPostInfoSize();
    },
    checkArtPostInfoSize() {
      const artPostInfoElement = document.getElementById('artPostInfo');
      const artPostElement = document.querySelector('.image-container-post');
      const artPostInfoWidth = artPostInfoElement.offsetWidth;
      const artPostInfoHeight = artPostInfoElement.offsetHeight;
      const artPostHeight = artPostElement?.offsetHeight || 0;
      if (((artPostInfoWidth < 500) || (artPostInfoHeight > artPostHeight)) && window.innerWidth < 1200) {     
        return true;
      }

      return false;
    },
    checkImageDimensions(imageUrl) {
      const img = new Image();
      img.onload = () => {
        this.imageIsLong = img.width <= img.height;
        this.onWindowResize();
      };
      img.src = imageUrl;
    },
    async fetchWebData(x, id) {
      this.loading = true;
      this.error = null;
      let urlFetcher = `${this.apiUrl}${x}${id}`;
      // Determine the field to use based on the art post structure
      fetch(urlFetcher)
        .then(response => {
          if (response.status === 403) {
            // Gallery is private
            this.isPrivate = true;
            throw new Error('Gallery is private');
          }
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          switch (x) {
            case '/api/artPosts/': {
              // Art post data - handle if it's an array
              const artPostData = Array.isArray(data) ? data[0] : data;
              this.artPost = artPostData;
              this.checkImageDimensions(artPostData.image_url);
              this.fetchWebData('/api/user/byid/', this.artPost.AssociatedUserID);
              this.updateDocumentTitle();
              break;
            }
            case '/api/user/byid/': {
              // User data - handle if it's an array
              const userData = Array.isArray(data) ? data[0] : data;
              this.userman = userData;
              this.updateDocumentTitle();
              break;
            }
            default:
              console.warn('Unexpected endpoint:', x);
              this.artPost = data;
              this.loading = false;
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          this.error = error.message || 'Failed to fetch data';
          this.loading = false;
          
          if (error.message !== 'Gallery is private') {
            // Only log non-privacy errors
            console.error('Unexpected error:', error);
          }
        });   
    },
  } 
};

</script>
